export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";